import React from "react";
import t from "../../components/I18N/TranslateHelpers";
import {useForm} from "react-hook-form";
import {INewsLetterProps, Newsletter} from "../Entity/Newsletter";
import {GetEmailRegex} from "../../components/UtilsForFormValidation";

const NewsletterForm : React.FC<INewsLetterProps> = (props:INewsLetterProps) => {
  const { register, handleSubmit, formState: { errors } } = useForm<Newsletter>();

  return(
    <section className="padding-y-sm bg-white position-relative shadow">
      <div className="container">
        <div className="row gy-3 align-items-center">
          <div className="col-lg-3">
            <div className="icontext">
              <div className="icon icon-sm bg-primary rounded">
                <i className="fa fa-envelope text-white"/>
              </div>
              <div className="text"><h5 className="mb-0">{t('dont_miss_thing')}</h5>
                <p className="text-muted mb-0">{ t('register_to_newsletter')}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-9">
            <form action="#" id="newsletter-form" onSubmit={handleSubmit(props.onSubmit)} className="subscription-newsletter py-5 ">
              <div className="row">
                <div className="col-md-4 col-lg-4">
                  <div className="input-group">
                    <label htmlFor="newsletterNameFirstname" className="newsletter-required">
                      {t('name')}
                    </label>
                    <input type="text" placeholder={t("name") + "*"} defaultValue={props.userDto?.lastName || ""}
                           className={errors.newsletterNameFirstname ? "form-control is-invalid" : "form-control"}
                           id="newsletterNameFirstname"  {... register("newsletterNameFirstname", {required: true})}/>
                    {errors.newsletterNameFirstname && <span className="invalid-feedback">{t("fields_required")}</span>}
                  </div>
                  <div className="input-group pt-2">
                    <label className="form-check">
                      <input className="form-check-input" type="checkbox" id="newsletterAccept"
                             {... register("newsletterAccept", {required: true})}
                      />
                      <span className="form-check-label"> { t("i_accept_condition")}
                      </span>
                    </label>
                    {errors.newsletterAccept && <span className="invalid-feedback">{t("accept_condition")}</span>}
                  </div>
                </div>
                <div className="col-md-4 col-lg-4">
                  <div className="input-group">
                    <label htmlFor="newsletterEmail" className="newsletter-required">{t('email')}</label>
                    <input type="email" placeholder={t("email") + "*"} defaultValue={props.userDto?.email || ""}
                           className={errors.newsletterEmail ? "form-control is-invalid" : "form-control"}
                           id="newsletterEmail"
                           {...register("newsletterEmail", {
                             required: true,
                             pattern: GetEmailRegex()
                           })}
                    />
                    {errors.newsletterEmail ? errors.newsletterEmail.type === 'pattern' ?
                      <span className="invalid-feedback">{t("invalid_address")}</span> :
                      <span className="invalid-feedback">{t("fields_required")}</span> : null}
                  </div>
                  <div className="input-group pt-2">
                    <a href={"/privacy-policy"} className="block">
                      {t('read_general_conditions')}
                    </a>
                  </div>
                </div>
                <div className="col-md-4 col-lg-4">
                  <nav className="float-lg-end">
                    {/*<span className="form-required"/>{t('warning_required_fields')}*/}
                    <label className="hidden-visible">{t('register_to_newsletter')}</label>
                    <button className="btn btn-primary rounded width100 form-text mt-0" type="submit">
                      {t('register_to_newsletter')}
                    </button>
                  </nav>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NewsletterForm;
